export const isEmpty = (element) => !element.length;

export const isPathnameEqualTo = (path) => window.location.pathname === path;

export const size = (element) => element.length;

export const getFromLocalStorage = (key) => window.localStorage.getItem(key);

export const setToLocalStorage = (key, value) => window.localStorage.setItem(key, value);